import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'
import useAllSitePage from '../../hooks/useAllSitePage'
import Button from '../../shared/Button/Button'
import './CardsList.scss'

const CardsList = ({ data }) => {
  const pagesPath = useAllSitePage()
  const { allSitePage: matchPages } = pagesPath
  const [ dataCards, setDataCards ] = useState([])

  useEffect(() => {
    setDataCards(data.cards.filter((card) => card.visible === true))
  }, [data.cards])

  return (
    <div className="container my-5 px-md-0 cards-list-container">
      {data.title && 
        <div className="d-flex align-items-center mb-4">
          <div className="flex-grow-1">
            <h2 className="cards-list-title text-uppercase">
              {data.title}
            </h2>
          </div>
        </div>
      }
      <div className="row">
        {dataCards.map((newItem, i) => {
          const texto = newItem.content?.split('#')
          let filtro = texto?.filter(Boolean)

          return newItem.visible && (
            <div
              key={ 'cardsList-' + i}
              className={`mb-4 col-12 ${newItem.destacado &&
                (dataCards.length === 1 || dataCards.length === 3 || dataCards.length === 5 || dataCards.length === 7)
                  ? 'col-md-12'
                  : 'col-md-6'
              }`}
            >
              <div
                className={`background-cards-style h-100`}
                style={{backgroundImage: `url(${
                  newItem.backgroundImage?.url
                  ? newItem.backgroundImage?.url
                  : 'none'
                }`}}
              >
                {(newItem.type || newItem.content) && (
                  <div className="text-white background d-flex flex-column h-100 justify-content-between">
                    <div className="h-100 d-flex justify-content-between flex-column position-relative">
                      {/* Etieta de las CARDs */}
                      {newItem.type && (
                        <div
                          className={'m-3 px-2 py-1 fit-cards-content '}
                          style={{
                            backgroundColor: newItem.color,
                            fontWeight: 'bold'
                          }}
                        >
                          {newItem.labelBlack === true ? (
                            <div className="text-black">{newItem.type}</div>
                          ) : (
                            <div>{newItem.type}</div>
                          )}
                        </div>
                      )}
                      
                      {newItem.content && (
                        <div
                          className={`p-3 d-flex flex-column justify-content-between ${!newItem.destacado
                            ? 'ucc-background-gradient '
                            : 'ucc-background-gradient-horizontal '
                            } `}
                        >
                          <ReactMarkdown
                            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                            className={`markdown-card ${( filtro && filtro[0].length > 18 ) ? 'text-content-card-title' : ''}`}
                            children={newItem.content}
                          />
                          <Button
                            classButton={` cards-button-style text-left button-form rounded-0`}
                            button={newItem}
                            matchPages={matchPages?.nodes}
                            customButton={{ variant: 'light_outline', size: "normal", shape: 'pill' }}
                            icon={newItem?.icon}
                            classContainer=" d-flex"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CardsList

CardsList.propTypes = {
  data: PropTypes.object.isRequired,
}
